/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketplaceLeadsLookupRequestApiModel } from '../../models/marketplace-leads-lookup-request-api-model';
import { MarketplaceLeadsMapApiModel } from '../../models/marketplace-leads-map-api-model';

export interface GetLeadsMap$Params {
      body: MarketplaceLeadsLookupRequestApiModel
}

export function getLeadsMap(http: HttpClient, rootUrl: string, params: GetLeadsMap$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketplaceLeadsMapApiModel>> {
  const rb = new RequestBuilder(rootUrl, getLeadsMap.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarketplaceLeadsMapApiModel>;
    })
  );
}

getLeadsMap.PATH = '/marketplace/map';
